module.exports = __webpack_public_path__ + "img/tgz@2x.ba46a130.png";